// ─── Pricing Endpoints ────────────────────────────────────────────────────────

export const API_GET_ALL_PRICING = '/admin/pslist/';
export const API_GET_PRICING_BY_ID = '/admin/psdetails/';
export const API_ADD_PRICING = '/admin/addps/';
export const API_EDIT_PRICING = '/admin/updateps/';
export const API_REMOVE_PRICING = '/admin/removeps/';
